export default __webpack_public_path__ + "static/media/logo_white.4ed01c6e.png";